import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import AppBarContainer from "../../components/shared/AppBarContainer";
import PageContentContainer from "../../components/shared/PageContentContainer";
import { ReactComponent as MessageES } from "../../assets/empty-states/messages-es.svg";
import { useEffect, useState } from "react";
import { MessagingAPIs } from "../../api/APIs";
import { useRequest } from "../../api/utils/useRequest";
import { useNavigate } from "react-router-dom";
import ArrowForward from "@mui/icons-material/ArrowForward";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSnackBar } from "../../context/SnackBarContext";
import CustomRectangularSkeleton from "../../components/shared/CustomRectangularSkeleton";
import CustomTextSkeleton from "../../components/shared/CustomTextSkeleton";
import MessageCard from "../../components/messages/MessageCard";

function MessagesPage() {
  const navigate = useNavigate();
  const openSnack = useSnackBar();
  const [messages, setMessages] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [error, serError] = useState(false);
  const {
    loading,
    result,
    apiCall: getMessages,
  } = useRequest(MessagingAPIs.getMessages, true);

  useEffect(() => {
    getPageMessages();
  }, []);

  const getPageMessages = () => {
    getMessages({
      data: { page: page },
      onSuccess: (response) => {
        setMessages((prev) => [...prev, ...response.content]);
        setHasMore(!response.last);
        setPage((prev) => prev + 1);
      },
      onError: (error) => {
        openSnack(true, { message: error.message });
        setHasMore(false);
        serError(true);
      },
    });
  };

  return (
    <>
      <AppBarContainer
        rightElement={
          <IconButton onClick={() => navigate(-1)}>
            <ArrowForward sx={{ color: "common.white" }} />
          </IconButton>
        }
        centerElement={
          <Typography variant="h5" color={"common.white"}>
            پیام‌ها
          </Typography>
        }
      />

      <PageContentContainer
        id="scrollableDiv"
        sx={{
          overflow: "auto",
          display: "block",
        }}
      >
        {loading && page === 0 ? (
          <>
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={60} />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={60} />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomRectangularSkeleton sx={{ mt: 2 }} height={60} />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
            <CustomTextSkeleton />
          </>
        ) : result && messages.length === 0 ? (
          <Box
            sx={{
              mt: 4,
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <MessageES width={126} height={160} />
            <Typography
              align="center"
              mt={1}
              variant="subtitle1"
              color="grey.4"
            >
              در صورت دریافت پیام یا اعلان جدید، می‌توانید آن را در این صفحه
              مشاهده کنید
            </Typography>
          </Box>
        ) : (
          result && (
            <InfiniteScroll
              dataLength={messages.length}
              next={getPageMessages}
              hasMore={hasMore}
              loader={
                <Box
                  sx={{
                    my: 1,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress size={14} />
                </Box>
              }
              scrollableTarget="scrollableDiv"
            >
              {messages.map((message, index) => {
                return (
                  <MessageCard
                    key={message.id}
                    message={message}
                    setMessages={setMessages}
                  />
                );
              })}
            </InfiniteScroll>
          )
        )}
      </PageContentContainer>
    </>
  );
}

export default MessagesPage;
